import * as React from 'react';
import BPromise from 'bluebird';
import propz from 'propz';
import moment from 'moment';
import { Component } from 'react';
import { AppUser } from 'Src/views/App/App';
import { History, Location } from 'history';
import { parse } from 'query-string';
import { TwoPanelEditor } from 'Src/components/TwoPanelEditor/TwoPanelEditor';
import { Loader } from 'Src/components/Loader/Loader';
import {
  getTournamentEligibleSchools,
  getTournamentEligibleSchoolsCount,
  getTournamentManagementSummary
} from 'Src/helpers/service/adminSU/tournamentsTable';
import { DEFAULT_SKIP, FILTER_TYPE } from 'Src/consts/table';
import {
  getTournamentInviteNormalizedStatus,
  getTournamentInviteNormalizedDate
} from 'Src/helpers/twoPanelEditor/twoPanelEditorAccessor';
import { getTwoPanelEditorFilters } from 'Src/helpers/twoPanelEditor/twoPanelEditor';
import { DATE_INTERVAL, LIMIT } from 'Src/consts/table';
import { getSelectOptionForTournamentParticipantsInviteStatus } from 'Src/helpers/twoPanelEditor/twoPanelEditorSelect';
import {
  ColumnDefinition,
  getOrder,
  getServerFieldSectionWhere,
  isFilterExist2,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import {
  addTournamentParticipants,
  getAllTournamentParticipants,
  getTournamentParticipantsCount,
  removeTournamentParticipant
} from 'Src/helpers/service/adminSU/tournamentParticipantsTable';
import { addTournamentTeamsBatch } from 'Src/helpers/service/admin/tournamentTeams';
import { getAllTournamentEligibleSchools, getTournament } from 'Src/helpers/service/adminSU/tournamentsTable';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { isIndividualTournament } from 'Src/helpers/tournament/tournament';
import { getTournamentCapacitySummary } from 'Src/helpers/tournament/tournament';
import { TEAM_TYPE } from 'Src/consts/team';
import { GENDER } from 'Src/consts/common';
import { AGE_GROUPS } from 'Src/consts/school';
import { TOURNAMENT_GENDER_SERVER_TO_CLIENT_MAPPING, TOURNAMENT_SCHOOL_LOGO_FALLBACK } from 'Src/consts/tournament';
import { UnsavedChangesModal } from 'Src/components/UnsavedChangesModal/UnsavedChangesModal';
import { getTournamentEvents } from 'Src/helpers/service/adminSU/tournamentEventsTable';
import { formatTeamAgesCompact } from 'Src/helpers/ageGroups';
import './TournamentParticipants2.scss';

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}
interface State {
  items: Item[];
  itemsSelected: Item[];
  itemsCount: number;

  itemsFilters: any;
  isShowItemsFilter: boolean;
  isItemsFiltered: boolean;

  isSelectAllItemsChecked: boolean;

  sortItemsDirection: TABLE_SORT_DIRECTION;
  sortItemsColumnsName: string;

  itemCurrentPage: number;
  itemsSearch: string;

  itemsAccumulatorInitial: Item[];
  itemsAccumulator: Item[];
  itemsAccumulatorSelected: Item[];
  itemsAccumulatorCount: number;

  itemsAccumulatorFilters: any;
  isShowItemsAccumulatorFilter: boolean;
  isItemsAccumulatorFiltered: boolean;

  isSelectAllItemsAccumulatorChecked: boolean;

  sortItemsAccumulatorDirection: TABLE_SORT_DIRECTION;
  sortItemsAccumulatorColumnsName: string;

  tournament: any;

  isLoading: boolean;
  isError: boolean;
  isDeleteParticipantsConfirmationModalOpen: boolean;

  itemsAddBuffer: Item[];
  itemsRemoveBuffer: Item[];
  isLeaveAlertOpen: boolean;
  teamsCount: number;
  waitingListCount: number;
  isEventSelectionOpen: boolean;
  isEventsLoading: boolean;
  participantEvents: any[];
  selectedParticipantEventIds: string[];
  participantEventSportSearch: string;
  eventSelectionError: string;
}

interface Item {
  id: string;
  name: string;
  inviteStatus: string;
  inviteStatusSetAt: string;
  isInviteAutoAccepted: string;
  participantId?: string;
  picUrl?: string;
}

const ITEMS_ACCUMULATOR_COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'name',
    accessor: ['name'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Invite Status',
    field: 'inviteStatus',
    accessor: getTournamentInviteNormalizedStatus,
    type: FILTER_TYPE.SELECT,
    isSort: false
  },
  {
    text: 'Date',
    field: 'inviteStatusSetAt',
    accessor: getTournamentInviteNormalizedDate,
    type: FILTER_TYPE.NONE,
    isSort: false
  }
];

const ITEMS_COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'name',
    accessor: ['name'],
    type: FILTER_TYPE.TEXT,
    isSort: true
  },
  {
    text: 'Invite Status',
    field: 'inviteStatus',
    accessor: getTournamentInviteNormalizedStatus,
    type: FILTER_TYPE.SELECT,
    isSort: false
  },
  {
    text: 'Date',
    field: 'inviteStatusSetAt',
    accessor: getTournamentInviteNormalizedDate,
    type: FILTER_TYPE.NONE,
    isSort: true
  }
];

export class TournamentParticipants2 extends Component<Props, State> {
  private unblockNavigation: (() => void) | undefined;
  private pendingLocation: any;

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      itemsCount: 0,
      itemsSelected: [],

      itemsFilters: {},
      isShowItemsFilter: false,
      isItemsFiltered: false,

      isSelectAllItemsChecked: false,

      sortItemsDirection: '',
      sortItemsColumnsName: '',

      itemCurrentPage: 1,
      itemsSearch: '',

      itemsAccumulatorInitial: [],
      itemsAccumulator: [],
      itemsAccumulatorCount: 0,
      itemsAccumulatorSelected: [],

      itemsAccumulatorFilters: {},
      isShowItemsAccumulatorFilter: false,
      isItemsAccumulatorFiltered: false,

      isSelectAllItemsAccumulatorChecked: false,

      sortItemsAccumulatorDirection: '',
      sortItemsAccumulatorColumnsName: '',

      tournament: undefined,
      teamsCount: 0,
      waitingListCount: 0,

      isLoading: false,
      isError: false,
      isDeleteParticipantsConfirmationModalOpen: false,

      itemsAddBuffer: [],
      itemsRemoveBuffer: [],
      isLeaveAlertOpen: false,
      isEventSelectionOpen: false,
      isEventsLoading: false,
      participantEvents: [],
      selectedParticipantEventIds: [],
      participantEventSportSearch: '',
      eventSelectionError: ''
    };
  }

  getTournamentId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const tournamentId = search.tournament;
    return tournamentId;
  }

  componentDidMount() {
    this.unblockNavigation = this.props.history.block(location => {
      if (!this.hasUnsavedChanges()) return undefined;
      this.pendingLocation = location;
      this.setState({ isLeaveAlertOpen: true });
      return false;
    });

    this.setState({
      isLoading: true
    });

    const { user } = this.props;
    const tournamentId = this.getTournamentId();

    const itemsFilters = getTwoPanelEditorFilters(ITEMS_COLUMNS);
    const isShowItemsFilter = isFilterExist2(itemsFilters);
    const isItemsFiltered = isFilterExist2(itemsFilters);

    const itemsAccumulatorFilters = getTwoPanelEditorFilters(ITEMS_ACCUMULATOR_COLUMNS);
    const isShowItemsAccumulatorFilter = isFilterExist2(itemsAccumulatorFilters);
    const isItemsAccumulatorFiltered = isFilterExist2(itemsAccumulatorFilters);

    let tournament;

    getTournament(user, tournamentId)
      .then(_tournament => {
        tournament = _tournament;
        return BPromise.all([
          this.getItemsAndItemsAccumulator(),
          getTournamentManagementSummary(user, tournamentId).catch(() => undefined)
        ]);
      })
      .then(
        ([
          { tournamentParticipantsInitial, tournamentParticipants, tournamentParticipantsCount, schools, schoolsCount },
          managementSummary
        ]) => {
          const schoolsNormalized = this.getSchoolsNormalized(schools);
          const tournamentParticipantsNormalized = this.getTournamentParticipantsNormalized(tournamentParticipants);
          const tournamentParticipantsInitialNormalized = this.getTournamentParticipantsNormalized(
            tournamentParticipantsInitial
          );

          this.setState({
            items: schoolsNormalized,
            itemsCount: schoolsCount.count,
            itemsFilters: itemsFilters,
            isShowItemsFilter: isShowItemsFilter,
            isItemsFiltered: isItemsFiltered,

            itemsAccumulatorInitial: tournamentParticipantsInitialNormalized,
            itemsAccumulator: tournamentParticipantsNormalized,
            itemsAccumulatorCount: tournamentParticipantsCount.count,
            itemsAccumulatorFilters: itemsAccumulatorFilters,
            isShowItemsAccumulatorFilter: isShowItemsAccumulatorFilter,
            isItemsAccumulatorFiltered: isItemsAccumulatorFiltered,

            tournament: tournament,
            teamsCount: Number(managementSummary ? managementSummary.teams : 0),
            waitingListCount: Number(managementSummary ? managementSummary.waiting : 0),

            isLoading: false
          });
        }
      );
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const wasDirty = prevState.itemsAddBuffer.length > 0 || prevState.itemsRemoveBuffer.length > 0;
    const isDirty = this.hasUnsavedChanges();
    if (wasDirty === isDirty) return;
    if (isDirty) window.addEventListener('beforeunload', this.onBeforeUnload);
    else window.removeEventListener('beforeunload', this.onBeforeUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.onBeforeUnload);
    if (this.unblockNavigation) this.unblockNavigation();
  }

  hasUnsavedChanges = () => this.state.itemsAddBuffer.length > 0 || this.state.itemsRemoveBuffer.length > 0;

  getParticipantChanges = (itemsAccumulator: Item[]) => {
    const initialById = new Map(
      (this.state.itemsAccumulatorInitial || []).map(item => [String(item.id), item] as [string, Item])
    );
    const currentIds = new Set((itemsAccumulator || []).map(item => String(item.id)));

    return {
      itemsAddBuffer: (itemsAccumulator || []).filter(item => !initialById.has(String(item.id))),
      itemsRemoveBuffer: (this.state.itemsAccumulatorInitial || []).filter(item => !currentIds.has(String(item.id)))
    };
  };

  onBeforeUnload = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = '';
  };

  getItemsAndItemsAccumulator() {
    const { user } = this.props;
    const { itemsAccumulatorFilters } = this.state;
    const tournamentId = this.getTournamentId();

    const where = getServerFieldSectionWhere(itemsAccumulatorFilters);
    const isParticipantsFiltered = Object.keys(where || {}).length > 0;

    const getTournamentParticipantsInitialPromise = getAllTournamentParticipants(user, tournamentId);
    // With no filters these used to be three identical/full participant queries.
    // Keep one full snapshot for change tracking and reuse it for the visible accumulator.
    const getTournamentParticipantsPromise = isParticipantsFiltered
      ? getAllTournamentParticipants(user, tournamentId, where)
      : getTournamentParticipantsInitialPromise;
    const getTournamentParticipantsCountPromise = isParticipantsFiltered
      ? getTournamentParticipantsCount(user, tournamentId, where)
      : getTournamentParticipantsInitialPromise.then(participants => ({ count: participants.length }));

    const promiseAccumulator = [
      getTournamentParticipantsInitialPromise,
      getTournamentParticipantsPromise,
      getTournamentParticipantsCountPromise
    ];

    let tournamentParticipantsInitial, tournamentParticipants, tournamentParticipantsCount;

    return BPromise.all(promiseAccumulator)
      .then(([_tournamentParticipantsInitial, _tournamentParticipants, _tournamentParticipantsCount]) => {
        tournamentParticipantsInitial = _tournamentParticipantsInitial;
        tournamentParticipants = _tournamentParticipants;
        tournamentParticipantsCount = _tournamentParticipantsCount;

        const tournamentParticipantsInitialNormalized = this.getTournamentParticipantsNormalized(
          tournamentParticipantsInitial
        );

        const filter = this.getItemsFilter(1, tournamentParticipantsInitialNormalized, []);

        const getSchoolsPromise = getTournamentEligibleSchools(user, tournamentId, filter);
        const getSchoolsCountPromise = getTournamentEligibleSchoolsCount(user, tournamentId, filter.where);

        const promiseItems = [getSchoolsPromise, getSchoolsCountPromise];

        return BPromise.all(promiseItems);
      })
      .then(([schools, schoolsCount]) => {
        return {
          tournamentParticipantsInitial,
          tournamentParticipants,
          tournamentParticipantsCount,
          schools,
          schoolsCount
        };
      });
  }

  getSchoolsNormalized(schools) {
    return schools.map(school => {
      return {
        id: school.id,
        name: school.name,
        inviteStatus: propz.get(school, ['invite', 'status']),
        inviteStatusSetAt: propz.get(school, ['invite', 'updatedAt']),
        isInviteAutoAccepted: propz.get(school, ['invite', 'isAutoAccepted']),
        picUrl: school.pic || school.picUrl || TOURNAMENT_SCHOOL_LOGO_FALLBACK
      };
    });
  }

  getTournamentParticipantsNormalized(tournamentParticipants) {
    return tournamentParticipants.map(tournamentParticipant => {
      return {
        id: tournamentParticipant.schoolId,
        name: tournamentParticipant.school.name,
        inviteStatus: propz.get(tournamentParticipant, ['invite', 'status']),
        inviteStatusSetAt: propz.get(tournamentParticipant, ['invite', 'updatedAt']),
        isInviteAutoAccepted: propz.get(tournamentParticipant, ['invite', 'isAutoAccepted']),
        participantId: tournamentParticipant.id,
        picUrl: propz.get(tournamentParticipant, ['school', 'pic'], '') || TOURNAMENT_SCHOOL_LOGO_FALLBACK
      };
    });
  }

  onItemClick = (index: number): void => {
    const { items, itemsSelected } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = itemsSelected.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...itemsSelected];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      itemsAccumulatorSelected: [],
      itemsSelected: selectedItemsUpdated
    });
  };

  onItemAccumulatorClick = (index: number): void => {
    const { itemsAccumulator, itemsAccumulatorSelected } = this.state;
    const selectedItem = itemsAccumulator[index];

    const selectedItemIndex = itemsAccumulatorSelected.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...itemsAccumulatorSelected];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      itemsAccumulatorSelected: selectedItemsUpdated,
      itemsSelected: []
    });
  };

  onAddClick = () => {
    const { itemsSelected, itemsAccumulatorInitial, itemsAccumulator, itemCurrentPage } = this.state;
    const { user } = this.props;

    const existingIds = new Set((itemsAccumulator || []).map(x => String(x.id)));
    const initialById = new Map((itemsAccumulatorInitial || []).map(item => [String(item.id), item] as [string, Item]));
    const restoredItems = itemsSelected
      .filter(item => !existingIds.has(String(item.id)))
      .map(item => initialById.get(String(item.id)) || item);
    const nextItemsAccumulator = [...itemsAccumulator, ...restoredItems];
    const { itemsAddBuffer: nextItemsAddBuffer, itemsRemoveBuffer: nextItemsRemoveBuffer } = this.getParticipantChanges(
      nextItemsAccumulator
    );

    this.setState({
      isLoading: true
    });

    const filter = this.getItemsFilter(itemCurrentPage, nextItemsAccumulator, []);
    const tournamentId = this.getTournamentId();
    const getSchoolsPromise = getTournamentEligibleSchools(user, tournamentId, filter);
    const getSchoolsCountPromise = getTournamentEligibleSchoolsCount(user, tournamentId, filter.where);
    const promiseItems = [getSchoolsPromise, getSchoolsCountPromise];

    BPromise.all(promiseItems).then(([schools, schoolsCount]) => {
      const schoolsNormalized = this.getSchoolsNormalized(schools);

      this.setState({
        items: schoolsNormalized,
        isLoading: false,
        itemsCount: schoolsCount.count,
        itemsAddBuffer: nextItemsAddBuffer,
        itemsRemoveBuffer: nextItemsRemoveBuffer,
        itemsAccumulator: nextItemsAccumulator,
        itemsAccumulatorCount: nextItemsAccumulator.length,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isSelectAllItemsChecked: false
      });
    });
  };

  onRemoveClick = () => {
    const { itemsAccumulatorSelected, itemsAccumulator, itemCurrentPage } = this.state;
    const { user } = this.props;

    const selectedIds = new Set((itemsAccumulatorSelected || []).map(x => String(x.id)));
    const nextItemsAccumulator = (itemsAccumulator || []).filter(
      itemAccumulator => !selectedIds.has(String(itemAccumulator.id))
    );
    const { itemsAddBuffer: nextItemsAddBuffer, itemsRemoveBuffer: nextItemsRemoveBuffer } = this.getParticipantChanges(
      nextItemsAccumulator
    );

    this.setState({
      isLoading: true
    });

    const filter = this.getItemsFilter(itemCurrentPage, nextItemsAccumulator, []);
    const tournamentId = this.getTournamentId();
    const getSchoolsPromise = getTournamentEligibleSchools(user, tournamentId, filter);
    const getSchoolsCountPromise = getTournamentEligibleSchoolsCount(user, tournamentId, filter.where);
    const promiseItems = [getSchoolsPromise, getSchoolsCountPromise];

    BPromise.all(promiseItems).then(([schools, schoolsCount]) => {
      const schoolsNormalized = this.getSchoolsNormalized(schools);

      this.setState({
        items: schoolsNormalized,
        isLoading: false,
        itemsCount: schoolsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isSelectAllItemsChecked: false,
        itemsAddBuffer: nextItemsAddBuffer,
        itemsRemoveBuffer: nextItemsRemoveBuffer,
        itemsAccumulator: nextItemsAccumulator,
        itemsAccumulatorCount: nextItemsAccumulator.length
      });
    });
  };

  openEventSelection = () => {
    this.setState({
      isEventSelectionOpen: true,
      isEventsLoading: true,
      participantEvents: [],
      selectedParticipantEventIds: [],
      participantEventSportSearch: '',
      eventSelectionError: ''
    });
    getTournamentEvents(
      this.props.user,
      this.getTournamentId(),
      { where: {}, skip: 0, limit: 3000, order: 'startTime ASC' },
      { summary: true }
    )
      .then((events: any[]) =>
        this.setState({
          participantEvents: events,
          selectedParticipantEventIds: events.map(event => event.id),
          isEventsLoading: false
        })
      )
      .catch(() =>
        this.setState({
          isEventsLoading: false,
          eventSelectionError: 'Tournament events could not be loaded. Close this window and try again.'
        })
      );
  };

  onClickSave = () => {
    const { itemsAddBuffer, tournament } = this.state;
    if (itemsAddBuffer.length > 0 && isIndividualTournament(tournament)) {
      this.openEventSelection();
      return;
    }
    this.saveParticipantChanges();
  };

  saveParticipantChanges = () => {
    const { itemsAddBuffer, itemsRemoveBuffer, tournament } = this.state;
    const { user } = this.props;

    const tournamentId = this.getTournamentId();

    const isItemsRemoveEmpty = itemsRemoveBuffer.length === 0;
    const isItemsAddEmpty = itemsAddBuffer.length === 0;

    switch (true) {
      case isItemsRemoveEmpty && isItemsAddEmpty:
        {
          this.setState({
            // set default values
            itemsSelected: [],
            itemsFilters: {},
            isShowItemsFilter: false,
            isItemsFiltered: false,
            isSelectAllItemsChecked: false,
            sortItemsDirection: '',
            sortItemsColumnsName: '',
            itemCurrentPage: 1,
            itemsAccumulatorSelected: [],
            itemsAccumulatorFilters: {},
            isShowItemsAccumulatorFilter: false,
            isItemsAccumulatorFiltered: false,
            isSelectAllItemsAccumulatorChecked: false,
            sortItemsAccumulatorDirection: '',
            sortItemsAccumulatorColumnsName: '',
            itemsAddBuffer: [],
            itemsRemoveBuffer: []
          });
        }
        break;
      case isItemsRemoveEmpty:
        {
          this.setState({
            isLoading: true
          });

          const dataToTransfer = {
            participants: itemsAddBuffer.map(item => item.id),
            eventIds: isIndividualTournament(tournament) ? this.state.selectedParticipantEventIds : undefined
          };

          addTournamentParticipants(user, tournamentId, dataToTransfer)
            .then(participants => {
              const schools = participants.map(participant => participant.school);

              return this.createDefaultTournamentTeams(schools);
            })
            .then(() => {
              return this.getItemsAndItemsAccumulator();
            })
            .then(
              ({
                tournamentParticipantsInitial,
                tournamentParticipants,
                tournamentParticipantsCount,
                schools,
                schoolsCount
              }) => {
                const schoolsNormalized = this.getSchoolsNormalized(schools);
                const tournamentParticipantsNormalized = this.getTournamentParticipantsNormalized(
                  tournamentParticipants
                );
                const tournamentParticipantsInitialNormalized = this.getTournamentParticipantsNormalized(
                  tournamentParticipantsInitial
                );

                this.setState({
                  // set default values
                  itemsSelected: [],
                  itemsFilters: {},
                  isShowItemsFilter: false,
                  isItemsFiltered: false,
                  isSelectAllItemsChecked: false,
                  sortItemsDirection: '',
                  sortItemsColumnsName: '',
                  itemCurrentPage: 1,
                  itemsAccumulatorSelected: [],
                  itemsAccumulatorFilters: {},
                  isShowItemsAccumulatorFilter: false,
                  isItemsAccumulatorFiltered: false,
                  isSelectAllItemsAccumulatorChecked: false,
                  sortItemsAccumulatorDirection: '',
                  sortItemsAccumulatorColumnsName: '',
                  itemsAddBuffer: [],
                  itemsRemoveBuffer: [],
                  //set items and items accumulator
                  items: schoolsNormalized,
                  itemsCount: schoolsCount.count,
                  itemsAccumulator: tournamentParticipantsNormalized,
                  itemsAccumulatorInitial: tournamentParticipantsInitialNormalized,
                  itemsAccumulatorCount: tournamentParticipantsCount.count,
                  isLoading: false
                });
              }
            );
        }
        break;
      default: {
        this.setState({
          isDeleteParticipantsConfirmationModalOpen: true
        });
      }
    }
  };

  createDefaultTournamentTeams = schools => {
    const { user } = this.props;
    const { tournament } = this.state;
    const { id: tournamentId, gender, ages, sportId } = tournament;

    const isIndividual = isIndividualTournament(tournament);

    let teamsData = [];

    if (isIndividual) {
      teamsData = schools.map(school => {
        const { id: schoolId, name: schoolName } = school;
        return {
          name: schoolName,
          ages,
          gender,
          sportId,
          schoolId,
          isAutoEnrolledTeam: true,
          teamType: TEAM_TYPE.ADHOC,
          players: []
        };
      });
    } else {
      const teamAge = Array.isArray(ages) ? ages[0] : ages;
      const teamAgeConverted = AGE_GROUPS['U5-U18'][teamAge];

      let baseName = '';
      if (gender === GENDER.MALE_ONLY || gender === GENDER.FEMALE_ONLY) {
        baseName = teamAgeConverted;
      } else {
        baseName = `${teamAgeConverted} ${TOURNAMENT_GENDER_SERVER_TO_CLIENT_MAPPING[gender]}`;
      }

      teamsData = schools.map(school => {
        return {
          name: baseName,
          ages,
          gender,
          sportId,
          schoolId: school.id,
          isAutoEnrolledTeam: true,
          teamType: TEAM_TYPE.ADHOC,
          players: []
        };
      });
    }

    return addTournamentTeamsBatch(user, tournamentId, teamsData);
  };

  onItemsFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.itemsFilters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = ITEMS_COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      itemsFilters: nextFilters
    });
  };

  onItemsAccumulatorFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.itemsAccumulatorFilters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = ITEMS_COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      itemsAccumulatorFilters: nextFilters
    });
  };

  onItemsFilterClick = (event): void => {
    event.preventDefault();

    const { isShowItemsFilter } = this.state;

    this.setState({
      isShowItemsFilter: !isShowItemsFilter
    });
  };

  onItemsAccumulatorFilterClick = (event): void => {
    event.preventDefault();

    const { isShowItemsAccumulatorFilter } = this.state;

    this.setState({
      isShowItemsAccumulatorFilter: !isShowItemsAccumulatorFilter
    });
  };

  getItemsFilter(page, itemsAccumulator, itemsAddBuffer, order?) {
    const { itemsFilters, itemsSearch } = this.state;

    let where = getServerFieldSectionWhere(itemsFilters);
    if (itemsSearch.trim()) where.name = { like: itemsSearch.trim(), options: 'i' };
    const allItems = [...itemsAccumulator, ...itemsAddBuffer];
    const ninIds = allItems.map(item => item.id);
    propz.set(where, ['id', '$nin'], ninIds);

    const normalizedOrder = typeof order === 'string' ? order.trim() : order;
    const isOrderExist = typeof normalizedOrder !== 'undefined' && normalizedOrder !== '';

    const filter = isOrderExist
      ? {
          where: where,
          limit: LIMIT,
          skip: (page - 1) * LIMIT,
          order: normalizedOrder
        }
      : {
          where: where,
          limit: LIMIT,
          skip: (page - 1) * LIMIT
        };

    return filter;
  }

  onItemsSearchChange = (value: string) => {
    const itemsSearch = value.trim();
    const { user } = this.props;
    const { itemsAccumulator, itemsAddBuffer } = this.state;
    const tournamentId = this.getTournamentId();

    this.setState({ isLoading: true, itemsSearch }, () => {
      const filter = this.getItemsFilter(1, itemsAccumulator, itemsAddBuffer);
      BPromise.all([
        getTournamentEligibleSchools(user, tournamentId, filter),
        getTournamentEligibleSchoolsCount(user, tournamentId, filter.where)
      ]).then(([schools, schoolsCount]) => {
        this.setState({
          items: this.getSchoolsNormalized(schools),
          itemsCount: schoolsCount.count,
          itemsSelected: [],
          isSelectAllItemsChecked: false,
          itemCurrentPage: 1,
          isLoading: false
        });
      }).catch(() => this.setState({ isLoading: false }));
    });
  };

  itemsSetCurrentPageParams = (currentPage: number): void => {
    const { user } = this.props;
    const { itemsAccumulator, sortItemsColumnsName, sortItemsDirection, itemsAddBuffer } = this.state;

    this.setState({
      isLoading: true
    });

    const orderForFilter = `${sortItemsColumnsName} ${sortItemsDirection}`.trim();

    const filter = this.getItemsFilter(currentPage, itemsAccumulator, itemsAddBuffer, orderForFilter);
    const tournamentId = this.getTournamentId();

    getTournamentEligibleSchools(user, tournamentId, filter).then(schools => {
      const schoolsNormalized = this.getSchoolsNormalized(schools);

      this.setState({
        itemCurrentPage: currentPage,
        items: schoolsNormalized,
        isLoading: false
      });
    });
  };

  itemsOnApplyFilterClick = () => {
    const { itemsAccumulator, itemsAddBuffer } = this.state;

    this.setState({
      isLoading: true
    });

    const filter = this.getItemsFilter(1, itemsAccumulator, itemsAddBuffer);

    const { user } = this.props;

    const tournamentId = this.getTournamentId();

    const getSchoolsPromise = getTournamentEligibleSchools(user, tournamentId, filter);
    const getSchoolsCountPromise = getTournamentEligibleSchoolsCount(user, tournamentId, filter.where);

    const promiseItems = [getSchoolsPromise, getSchoolsCountPromise];

    BPromise.all(promiseItems).then(([schools, schoolsCount]) => {
      const schoolsNormalized = this.getSchoolsNormalized(schools);

      this.setState({
        items: schoolsNormalized,
        isLoading: false,
        itemsCount: schoolsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsDirection: '',
        sortItemsColumnsName: ''
      });
    });
  };

  itemsAccumulatorOnApplyFilterClick = () => {
    const { itemsAccumulatorFilters, itemsRemoveBuffer } = this.state;
    this.setState({
      isLoading: true
    });

    let where = getServerFieldSectionWhere(itemsAccumulatorFilters);
    const ninIds = itemsRemoveBuffer.map(item => item.id);
    propz.set(where, ['id', '$nin'], ninIds);

    const { user } = this.props;

    const tournamentId = this.getTournamentId();

    const getTournamentParticipantsPromise = getAllTournamentParticipants(user, tournamentId, where);
    const getTournamentParticipantsCountPromise = getTournamentParticipantsCount(user, tournamentId, where);

    const promiseItems = [getTournamentParticipantsPromise, getTournamentParticipantsCountPromise];

    BPromise.all(promiseItems).then(([tournamentParticipants, tournamentParticipantsCount]) => {
      const tournamentParticipantsNormalized = this.getTournamentParticipantsNormalized(tournamentParticipants);

      this.setState({
        itemsAccumulator: tournamentParticipantsNormalized,
        isLoading: false,
        itemsAccumulatorCount: tournamentParticipantsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: []
      });
    });
  };

  itemsOnClearFilterClick = () => {
    const { itemsAccumulatorInitial, itemsAddBuffer } = this.state;

    this.setState({
      isLoading: true
    });
    const allItems = [...itemsAccumulatorInitial, ...itemsAddBuffer];
    const ninIds = allItems.map(item => item.id);

    const filter = {
      where: { id: { $nin: ninIds } },
      limit: LIMIT,
      skip: DEFAULT_SKIP
    };

    const { user } = this.props;
    const tournamentId = this.getTournamentId();

    const getSchoolsPromise = getTournamentEligibleSchools(user, tournamentId, filter);
    const getSchoolsCountPromise = getTournamentEligibleSchoolsCount(user, tournamentId, filter.where);

    const promiseItems = [getSchoolsPromise, getSchoolsCountPromise];

    BPromise.all(promiseItems).then(([schools, schoolsCount]) => {
      const schoolsNormalized = this.getSchoolsNormalized(schools);

      this.setState({
        items: schoolsNormalized,
        isLoading: false,
        itemsCount: schoolsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        itemsFilters: {},
        sortItemsColumnsName: '',
        sortItemsDirection: ''
      });
    });
  };

  itemsAccumulatorOnClearFilterClick = () => {
    this.setState({
      isLoading: true
    });

    const { user } = this.props;
    const tournamentId = this.getTournamentId();
    const { itemsRemoveBuffer } = this.state;

    const getTournamentParticipantsPromise = getAllTournamentParticipants(user, tournamentId);
    const getTournamentParticipantsCountPromise = getTournamentParticipantsCount(user, tournamentId);

    const promiseItems = [getTournamentParticipantsPromise, getTournamentParticipantsCountPromise];

    BPromise.all(promiseItems).then(([tournamentParticipants, tournamentParticipantsCount]) => {
      const tournamentParticipantsNormalized = this.getTournamentParticipantsNormalized(tournamentParticipants);
      const nextTournamentParticipantsNormalized = tournamentParticipantsNormalized.filter(
        tournamentParticipantNormalized =>
          itemsRemoveBuffer.every(item => item.id !== tournamentParticipantNormalized.id)
      );

      this.setState({
        itemsAccumulator: nextTournamentParticipantsNormalized,
        isLoading: false,
        itemsAccumulatorCount: tournamentParticipantsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemsAccumulatorFilters: {}
      });
    });
  };

  goBack = (force = false) => {
    if (this.hasUnsavedChanges() && !force) {
      this.setState({ isLeaveAlertOpen: true });
      return;
    }
    const { history, location } = this.props;
    const tournamentId = this.getTournamentId();

    history.push({
      pathname: '/tournaments/manage/entries/participants',
      search: `tournament=${tournamentId}`,
      state: location.state
    });
  };

  confirmLeave = () => {
    const pendingLocation = this.pendingLocation;
    this.pendingLocation = undefined;
    this.setState({ itemsAddBuffer: [], itemsRemoveBuffer: [], isLeaveAlertOpen: false }, () => {
      if (this.unblockNavigation) {
        this.unblockNavigation();
        this.unblockNavigation = undefined;
      }
      if (pendingLocation) {
        this.props.history.push(pendingLocation);
        return;
      }
      this.goBack(true);
    });
  };

  keepEditing = () => {
    this.pendingLocation = undefined;
    this.setState({ isLeaveAlertOpen: false });
  };

  onSelectAllItemsClick = () => {
    const { itemsSelected, itemsFilters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(itemsFilters);

    const tournamentId = this.getTournamentId();

    getAllTournamentEligibleSchools(user, tournamentId, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return itemsSelected.every(selectedItem => selectedItem.id !== item.id);
      });

      const nextSelectedItems = [...itemsSelected, ...itemsFiltered];

      this.setState({
        itemsSelected: nextSelectedItems,
        isSelectAllItemsChecked: true,
        itemsAccumulatorSelected: [],
        isSelectAllItemsAccumulatorChecked: false,
        isLoading: false
      });
    });
  };

  onSelectAllItemsOnPageClick = () => {
    const { items, itemsSelected } = this.state;

    const itemsFiltered = items.filter(item => {
      return itemsSelected.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...itemsSelected, ...itemsFiltered];

    this.setState({
      itemsSelected: nextSelectedItems,
      isSelectAllItemsChecked: true,
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false
    });
  };

  onUnselectAllItemsClick = () => {
    this.setState({
      itemsSelected: [],
      isSelectAllItemsChecked: false,
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false
    });
  };

  onSelectAllItemsAccumulatorClick = () => {
    const { itemsAccumulatorSelected, itemsAccumulatorFilters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(itemsAccumulatorFilters);

    const tournamentId = this.getTournamentId();

    getAllTournamentParticipants(user, tournamentId, where).then(tournamentParticipants => {
      const tournamentParticipantsNormalized = this.getTournamentParticipantsNormalized(tournamentParticipants);

      const tournamentParticipantsFiltered = tournamentParticipantsNormalized.filter(tournamentParticipant => {
        return itemsAccumulatorSelected.every(selectedItem => selectedItem.id !== tournamentParticipant.id);
      });

      const nextSelectedItems = [...itemsAccumulatorSelected, ...tournamentParticipantsFiltered];

      this.setState({
        itemsAccumulatorSelected: nextSelectedItems,
        isSelectAllItemsAccumulatorChecked: true,
        itemsSelected: [],
        isSelectAllItemsChecked: false,
        isLoading: false
      });
    });
  };

  onSelectAllItemsAccumulatorOnPageClick = () => {
    const { itemsAccumulator, itemsAccumulatorSelected } = this.state;

    const itemsFiltered = itemsAccumulator.filter(item => {
      return itemsAccumulatorSelected.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...itemsAccumulatorSelected, ...itemsFiltered];

    this.setState({
      itemsAccumulatorSelected: nextSelectedItems,
      isSelectAllItemsAccumulatorChecked: true,
      itemsSelected: [],
      isSelectAllItemsChecked: false
    });
  };

  onUnselectAllItemsAccumulatorClick = () => {
    this.setState({
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false,
      itemsSelected: [],
      isSelectAllItemsChecked: false
    });
  };

  onSortItemsClick = (sortField: string) => {
    const { sortItemsDirection, sortItemsColumnsName, itemCurrentPage, itemsAccumulator, itemsAddBuffer } = this.state;

    const order = getOrder(sortField, sortItemsDirection, sortItemsColumnsName) as TABLE_SORT_DIRECTION;
    const orderForFilter = `${sortField} ${order}`;

    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulator, itemsAddBuffer, orderForFilter);
    const { user } = this.props;
    const tournamentId = this.getTournamentId();
    const getSchoolsPromise = getTournamentEligibleSchools(user, tournamentId, filter);
    const getSchoolsCountPromise = getTournamentEligibleSchoolsCount(user, tournamentId, filter.where);

    const promiseItems = [getSchoolsPromise, getSchoolsCountPromise];

    BPromise.all(promiseItems).then(([schools, schoolsCount]) => {
      const schoolsNormalized = this.getSchoolsNormalized(schools);

      this.setState({
        items: schoolsNormalized,
        isLoading: false,
        itemsCount: schoolsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsColumnsName: sortField,
        sortItemsDirection: order
      });
    });
  };

  onSortItemsAccumulatorClick = (sortField: string) => {};

  onCloseErrorClick = () => {
    this.setState({
      isError: false
    });
  };

  renderError(): React.ReactNode {
    const { isError } = this.state;
    const errorMessage =
      'The school you are trying to remove is taking part in some events within the tournament. ' +
      'Please, remove those events first to be able to exclude the school from the competition.';

    return (
      <SimpleModal
        isOpen={isError}
        title={'Remove from tournament'}
        body={errorMessage}
        onCloseClick={this.onCloseErrorClick}
        buttonCancelText={'Ok'}
      />
    );
  }

  onCloseDeleteSchoolConfirmationModalClick = () => {
    this.setState({
      isDeleteParticipantsConfirmationModalOpen: false
    });
  };

  onDeleteParticipantModalClick = () => {
    const { itemsRemoveBuffer, itemsAddBuffer } = this.state;
    const { user } = this.props;
    const tournamentId = this.getTournamentId();

    this.setState({
      isLoading: true
    });

    BPromise.each(itemsRemoveBuffer, (item, index) => {
      return removeTournamentParticipant(user, tournamentId, item.participantId);
    })
      .then(async res => {
        if (itemsAddBuffer.length > 0) {
          const dataToTransfer = {
            participants: itemsAddBuffer.map(item => item.id),
            eventIds: isIndividualTournament(this.state.tournament) ? this.state.selectedParticipantEventIds : undefined
          };
          const participants = await addTournamentParticipants(user, tournamentId, dataToTransfer);

          const schools = participants.map(p => p.school);
          await this.createDefaultTournamentTeams(schools);

          return participants;
        } else {
          return true;
        }
      })
      .catch(err => {
        this.setState({
          // set default values
          itemsSelected: [],
          itemsFilters: {},
          isShowItemsFilter: false,
          isItemsFiltered: false,
          isSelectAllItemsChecked: false,
          sortItemsDirection: '',
          sortItemsColumnsName: '',
          itemCurrentPage: 1,
          itemsAccumulatorSelected: [],
          itemsAccumulatorFilters: {},
          isShowItemsAccumulatorFilter: false,
          isItemsAccumulatorFiltered: false,
          isSelectAllItemsAccumulatorChecked: false,
          sortItemsAccumulatorDirection: '',
          sortItemsAccumulatorColumnsName: '',
          itemsAddBuffer: [],
          itemsRemoveBuffer: [],
          //show error
          isError: true
        });
      })
      .then(res => {
        this.setState({
          // set default values
          itemsSelected: [],
          itemsFilters: {},
          isShowItemsFilter: false,
          isItemsFiltered: false,
          isSelectAllItemsChecked: false,
          sortItemsDirection: '',
          sortItemsColumnsName: '',
          itemCurrentPage: 1,
          itemsAccumulatorSelected: [],
          itemsAccumulatorFilters: {},
          isShowItemsAccumulatorFilter: false,
          isItemsAccumulatorFiltered: false,
          isSelectAllItemsAccumulatorChecked: false,
          sortItemsAccumulatorDirection: '',
          sortItemsAccumulatorColumnsName: '',
          itemsAddBuffer: [],
          itemsRemoveBuffer: []
        });
      })
      .then(res => {
        return this.getItemsAndItemsAccumulator();
      })
      .then(
        ({
          tournamentParticipantsInitial,
          tournamentParticipants,
          tournamentParticipantsCount,
          schools,
          schoolsCount
        }) => {
          const schoolsNormalized = this.getSchoolsNormalized(schools);
          const tournamentParticipantsNormalized = this.getTournamentParticipantsNormalized(tournamentParticipants);
          const tournamentParticipantsInitialNormalized = this.getTournamentParticipantsNormalized(
            tournamentParticipantsInitial
          );

          this.setState({
            //set items and items accumulator
            items: schoolsNormalized,
            itemsCount: schoolsCount.count,
            itemsAccumulator: tournamentParticipantsNormalized,
            itemsAccumulatorInitial: tournamentParticipantsInitialNormalized,
            itemsAccumulatorCount: tournamentParticipantsCount.count,
            isLoading: false,
            isDeleteParticipantsConfirmationModalOpen: false
          });
        }
      );
  };

  renderDeleteParticipantConfirmationModal(): React.ReactNode {
    const { isDeleteParticipantsConfirmationModalOpen } = this.state;
    const { itemsRemoveBuffer } = this.state;

    return (
      <SimpleModal
        isOpen={isDeleteParticipantsConfirmationModalOpen}
        title={`Remove ${itemsRemoveBuffer.length === 1 ? 'school' : 'schools'} from participants?`}
        onButtonClick={this.onDeleteParticipantModalClick}
        body={
          <div className="utmParticipantsManager__removeConfirmation">
            <div className="utmParticipantsManager__removeWarning">
              <span aria-hidden="true">!</span>
              <p>
                {itemsRemoveBuffer.length === 1 ? 'This school' : 'These schools'} will be removed from the tournament
                participants. Any tournament teams belonging to them must no longer be assigned to events.
              </p>
            </div>
            <div className="utmParticipantsManager__removeListLabel">
              {itemsRemoveBuffer.length === 1 ? 'School to remove' : `${itemsRemoveBuffer.length} schools to remove`}
            </div>
            <ul className="utmParticipantsManager__removeList">
              {itemsRemoveBuffer.map(item => (
                <li key={item.id}>{item.name}</li>
              ))}
            </ul>
            <p className="utmParticipantsManager__removeNote">
              This changes their tournament access and cannot be undone from this screen. You can add a school again
              later if needed.
            </p>
          </div>
        }
        bodyClassName="utmParticipantsManager__removeModalBody"
        customClass="utmParticipantsManager__removeDialog"
        dialogStyle={{ maxWidth: 520 }}
        isBodyBold={false}
        buttonText={itemsRemoveBuffer.length === 1 ? 'Remove school' : `Remove ${itemsRemoveBuffer.length} schools`}
        onCloseClick={this.onCloseDeleteSchoolConfirmationModalClick}
      />
    );
  }

  getParticipantEventName = (event: any): string => {
    const generatedNames = event.generatedNames || {};
    const fallbackName = [
      event.sport?.name,
      formatTeamAgesCompact(event.ages, 'ENGLISH'),
      TOURNAMENT_GENDER_SERVER_TO_CLIENT_MAPPING[event.gender] || event.gender
    ].filter(Boolean).join(' · ');
    return String(
      event.eventDetails?.shortDescription ||
        event.shortDescription ||
        fallbackName ||
        generatedNames[this.props.user.activeSchoolId] ||
        generatedNames.official ||
        event.generatedName ||
        'Tournament event'
    );
  };

  renderEventSelectionModal(): React.ReactNode {
    const search = this.state.participantEventSportSearch.trim().toLowerCase();
    const visibleEvents = search
      ? this.state.participantEvents.filter(event =>
          String(event.sport?.name || '')
            .toLowerCase()
            .includes(search)
        )
      : this.state.participantEvents;
    const areAllVisibleSelected =
      visibleEvents.length > 0 &&
      visibleEvents.every(event => this.state.selectedParticipantEventIds.includes(event.id));
    const setVisibleSelected = (isSelected: boolean) => {
      const visibleIds = visibleEvents.map(event => event.id);
      this.setState(state => ({
        selectedParticipantEventIds: isSelected
          ? Array.from(new Set([...state.selectedParticipantEventIds, ...visibleIds]))
          : state.selectedParticipantEventIds.filter(id => !visibleIds.includes(id))
      }));
    };

    return (
      <SimpleModal
        isOpen={this.state.isEventSelectionOpen}
        title="Add schools to existing events"
        buttonText="Continue"
        buttonDisabled={this.state.isEventsLoading || Boolean(this.state.eventSelectionError)}
        onButtonClick={() => this.setState({ isEventSelectionOpen: false }, this.saveParticipantChanges)}
        onCloseClick={() => this.setState({ isEventSelectionOpen: false, eventSelectionError: '' })}
        customClass="unionTournamentDeleteModal"
        dialogStyle={{ maxWidth: 640 }}
        isBodyBold={false}
      >
        <p>
          Choose which existing events the {this.state.itemsAddBuffer.length === 1 ? 'school' : 'schools'} will be
          invited to. All events are selected by default.
        </p>
        <div className="utmEligibleAddModal__events">
          <div>
            <strong>Existing events</strong>
            <span>
              {this.state.selectedParticipantEventIds.length} of {this.state.participantEvents.length} selected
            </span>
          </div>
          {this.state.participantEvents.length ? (
            <div className="utmEligibleAddModal__eventTools">
              <label>
                <svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">
                  <circle cx="11" cy="11" r="6.5" />
                  <path d="m16 16 4 4" />
                </svg>
                <input
                  type="search"
                  value={this.state.participantEventSportSearch}
                  onChange={event => this.setState({ participantEventSportSearch: event.target.value })}
                  placeholder="Search by sport"
                />
              </label>
              <label className="utmEligibleAddModal__selectAll">
                <input type="checkbox" checked={areAllVisibleSelected} onChange={event => setVisibleSelected(event.target.checked)} disabled={!visibleEvents.length} />
                <span aria-hidden="true" />
                Select all{search ? ' results' : ''}
              </label>
            </div>
          ) : null}
          {this.state.isEventsLoading ? <p>Loading events…</p> : null}
          {!this.state.isEventsLoading && !this.state.participantEvents.length ? (
            <p>No existing events. The schools will be added to the tournament only.</p>
          ) : null}
          {!this.state.isEventsLoading && this.state.participantEvents.length > 0 && !visibleEvents.length ? (
            <p>No events found for this sport.</p>
          ) : null}
          {visibleEvents.map(event => (
            <label key={event.id}>
              <input
                type="checkbox"
                checked={this.state.selectedParticipantEventIds.includes(event.id)}
                onChange={() =>
                  this.setState(state => ({
                    selectedParticipantEventIds: state.selectedParticipantEventIds.includes(event.id)
                      ? state.selectedParticipantEventIds.filter(id => id !== event.id)
                      : [...state.selectedParticipantEventIds, event.id]
                  }))
                }
              />
              <span>
                <strong>{this.getParticipantEventName(event)}</strong>
                <small>
                  {event.startTime ? moment(event.startTime).format('DD MMM YYYY, HH:mm') : 'Time not set'} ·{' '}
                  {event.sport?.name || 'Sport not set'} ·{' '}
                  {TOURNAMENT_GENDER_SERVER_TO_CLIENT_MAPPING[event.gender] || event.gender || 'Gender not set'} ·{' '}
                  {formatTeamAgesCompact(event.ages, 'ENGLISH') || 'Ages not set'}
                </small>
              </span>
            </label>
          ))}
        </div>
        {this.state.eventSelectionError ? (
          <div className="utmEligible__removeError">{this.state.eventSelectionError}</div>
        ) : null}
      </SimpleModal>
    );
  }

  render() {
    const {
      items,
      isLoading,
      itemsSelected,
      itemsAccumulatorSelected,
      itemsAccumulator,
      itemsFilters,
      isShowItemsFilter,
      isItemsFiltered,
      itemsCount,
      itemsAccumulatorCount,
      itemCurrentPage,
      itemsAccumulatorFilters,
      isShowItemsAccumulatorFilter,
      isItemsAccumulatorFiltered,
      tournament,
      isSelectAllItemsChecked,
      isSelectAllItemsAccumulatorChecked,
      sortItemsDirection,
      sortItemsColumnsName,
      sortItemsAccumulatorDirection,
      sortItemsAccumulatorColumnsName,
      itemsAddBuffer,
      itemsRemoveBuffer,
      isError,
      isDeleteParticipantsConfirmationModalOpen
    } = this.state;

    const name = propz.get(tournament, ['name'], '');

    if (isLoading) {
      return <Loader />;
    }

    const itemsFiltersOptions = {
      inviteStatus: getSelectOptionForTournamentParticipantsInviteStatus()
    };

    const itemsAccumulatorFiltersOptions = {
      inviteStatus: getSelectOptionForTournamentParticipantsInviteStatus()
    };

    const classes = isError || isDeleteParticipantsConfirmationModalOpen ? 'modal-open' : '';
    const start = tournament && tournament.startTime ? moment(tournament.startTime) : null;
    const end = tournament && tournament.endTime ? moment(tournament.endTime) : null;
    const dateLabel = start && start.isValid() ? start.format('ddd D MMM YYYY') : 'Date not set';
    const timeLabel =
      start && start.isValid()
        ? `${start.format('HH:mm')}${end && end.isValid() ? ` – ${end.format('HH:mm')}` : ''}`
        : 'Time not set';
    const capacitySummary = tournament
      ? getTournamentCapacitySummary(
          tournament,
          isIndividualTournament(tournament) ? itemsAccumulatorCount : this.state.teamsCount
        )
      : { booked: 0, capacity: 0, unlimited: true };
    const availablePlaces = capacitySummary.unlimited
      ? 'Unlimited'
      : Math.max(0, capacitySummary.capacity - capacitySummary.booked);

    return (
      <main className="utmParticipantsManager">
        <UnsavedChangesModal
          isOpen={this.state.isLeaveAlertOpen}
          message="You have unsaved participant changes. If you leave now, those changes will be lost."
          onKeepEditing={this.keepEditing}
          onDiscard={this.confirmLeave}
        />
        <div className={classes}>
          {this.renderError()}
          {this.renderDeleteParticipantConfirmationModal()}
          {this.renderEventSelectionModal()}
        </div>

        <header className="utmParticipantsManager__header">
          <div className="utmParticipantsManager__summaryCard">
            <button type="button" className="utmParticipantsManager__back" onClick={() => this.goBack()}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="m15 18-6-6 6-6" />
              </svg>
              Back to tournament
            </button>
            <div className="utmParticipantsManager__summaryMain">
              <span className="utmParticipantsManager__eyebrow">Manage participants</span>
              <div className="utmParticipantsManager__summaryTitle">{name}</div>
              <div className="utmParticipantsManager__summaryDate">
                {dateLabel} · {timeLabel}
              </div>
              <div className="utmParticipantsManager__summaryChips">
                <span>
                  <b>{capacitySummary.booked}</b> places occupied
                </span>
                <span className="is-available">
                  <b>{availablePlaces}</b> places available
                </span>
                <span>
                  <b>{itemsAccumulatorCount}</b> {itemsAccumulatorCount === 1 ? 'school' : 'schools'}
                </span>
                <span>
                  <b>{this.state.teamsCount}</b> {this.state.teamsCount === 1 ? 'team' : 'teams'}
                </span>
                <span className={this.state.waitingListCount ? 'is-waiting' : ''}>
                  <b>{this.state.waitingListCount}</b> waiting list
                </span>
              </div>
            </div>
          </div>
        </header>

        <section className="utmParticipantsManager__participantsCard">
          <div className="utmParticipantsManager__participantsHead">
            <div>
              <h2>Manage participants</h2>
              <p>
                Double-click a row to move it instantly, or tick several and use the centre buttons. Changes apply when
                you save.
              </p>
            </div>
          </div>
          <div className="utmParticipantsManager__participantsDivider" />
          <div className="utmParticipantsManager__editorWrap">
            <TwoPanelEditor
              //items
              items={items}
              itemsTitle={'Available schools'}
              itemsColumns={ITEMS_COLUMNS}
              itemsSelected={itemsSelected}
              onItemClick={this.onItemClick}
              //items filters
              onItemsFilterChange={this.onItemsFilterChange}
              itemsFilters={itemsFilters}
              itemsFiltersOptions={itemsFiltersOptions}
              isShowItemsFilter={isShowItemsFilter}
              isItemsFiltered={isItemsFiltered}
              onItemsFilterClick={this.onItemsFilterClick}
              //accumulator
              itemsAccumulator={itemsAccumulator}
              itemsAccumulatorTitle={'Tournament participants'}
              itemsAccumulatorColumns={ITEMS_ACCUMULATOR_COLUMNS}
              onItemAccumulatorClick={this.onItemAccumulatorClick}
              itemsAccumulatorSelected={itemsAccumulatorSelected}
              //accumulator filters
              onItemsAccumulatorFilterChange={this.onItemsAccumulatorFilterChange}
              itemsAccumulatorFilters={itemsAccumulatorFilters}
              itemsAccumulatorFiltersOptions={itemsAccumulatorFiltersOptions}
              isShowItemsAccumulatorFilter={isShowItemsAccumulatorFilter}
              isItemsAccumulatorFiltered={isItemsAccumulatorFiltered}
              onItemsAccumulatorFilterClick={this.onItemsAccumulatorFilterClick}
              //buttons
              onAddClick={this.onAddClick}
              onRemoveClick={this.onRemoveClick}
              //counts
              itemsCount={itemsCount}
              itemsAccumulatorCount={itemsAccumulatorCount}
              //current pages
              itemAccumulatorCurrentPage={1}
              itemCurrentPage={itemCurrentPage}
              itemsSetCurrentPageParams={this.itemsSetCurrentPageParams}
              //items filter buttons
              itemsOnApplyFilterClick={this.itemsOnApplyFilterClick}
              itemsOnClearFilterClick={this.itemsOnClearFilterClick}
              //items accumulator filter buttons
              itemsAccumulatorOnApplyFilterClick={this.itemsAccumulatorOnApplyFilterClick}
              itemsAccumulatorOnClearFilterClick={this.itemsAccumulatorOnClearFilterClick}
              //items select checkbox
              onSelectAllItemsClick={this.onSelectAllItemsClick}
              onSelectAllItemsOnPageClick={this.onSelectAllItemsOnPageClick}
              onUnselectAllItemsClick={this.onUnselectAllItemsClick}
              isSelectAllItemsChecked={isSelectAllItemsChecked}
              //items accumulator select checkbox
              onSelectAllItemsAccumulatorClick={this.onSelectAllItemsAccumulatorClick}
              onSelectAllItemsAccumulatorOnPageClick={this.onSelectAllItemsAccumulatorOnPageClick}
              onUnselectAllItemsAccumulatorClick={this.onUnselectAllItemsAccumulatorClick}
              isSelectAllItemsAccumulatorChecked={isSelectAllItemsAccumulatorChecked}
              //items sort
              sortItemsDirection={sortItemsDirection}
              sortItemsColumnsName={sortItemsColumnsName}
              onSortItemsClick={this.onSortItemsClick}
              //items accumulator sort
              sortItemsAccumulatorDirection={sortItemsAccumulatorDirection}
              sortItemsAccumulatorColumnsName={sortItemsAccumulatorColumnsName}
              onSortItemsAccumulatorClick={this.onSortItemsAccumulatorClick}
              itemsAddBuffer={itemsAddBuffer}
              itemsRemoveBuffer={itemsRemoveBuffer}
              isSourceFirst
              unitLabel="schools"
              itemsModernPagination
              onItemsSearchChange={this.onItemsSearchChange}
              itemsSearchValue={this.state.itemsSearch}
              itemsSearchByNameOnly
              showFilterControl={false}
              showAvatars
            />
          </div>
        </section>

        <footer className="utmParticipantsManager__footer">
          <span>
            {itemsAddBuffer.length || itemsRemoveBuffer.length
              ? `${itemsAddBuffer.length + itemsRemoveBuffer.length} pending ${
                  itemsAddBuffer.length + itemsRemoveBuffer.length === 1 ? 'change' : 'changes'
                }`
              : 'No pending changes'}
          </span>
          <div>
            <button type="button" className="is-secondary" onClick={() => this.goBack()}>
              Cancel
            </button>
            <button
              type="button"
              className="is-primary"
              onClick={this.onClickSave}
              disabled={itemsAddBuffer.length === 0 && itemsRemoveBuffer.length === 0}
            >
              Save changes
            </button>
          </div>
        </footer>
      </main>
    );
  }
}
